import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecommendationResults = ({ recommendations, onServiceSelect, onStartOver }) => {
  if (!recommendations || recommendations.length === 0) return null;

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="CheckCircle" size={20} className="text-success" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Recommended Services</h3>
            <p className="text-sm text-text-secondary">Based on your specific challenges and requirements</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onStartOver}
          iconName="RotateCcw"
          iconPosition="left"
        >
          Start Over
        </Button>
      </div>

      <div className="space-y-4">
        {recommendations.map((rec, index) => (
          <div
            key={rec.service.id}
            className={`border rounded-lg p-4 transition-all duration-200 ${
              index === 0 
                ? 'border-accent bg-accent/5' :'border-border hover:border-accent/50'
            }`}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${rec.service.iconBg}`}>
                  <Icon name={rec.service.icon} size={20} className={rec.service.iconColor} />
                </div>
                <div>
                  <h4 className="font-semibold text-text-primary">{rec.service.title}</h4>
                  <p className="text-sm text-text-secondary">{rec.service.subtitle}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                {index === 0 && (
                  <span className="px-2 py-1 bg-accent text-accent-foreground text-xs font-medium rounded-full">
                    Best Match
                  </span>
                )}
                <div className="flex items-center space-x-1">
                  <Icon name="Star" size={14} className="text-warning fill-current" />
                  <span className="text-sm font-medium text-text-primary">{rec.score}%</span>
                </div>
              </div>
            </div>

            <p className="text-sm text-text-secondary mb-4 leading-relaxed">
              {rec.reasoning}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-4">
              <div className="bg-muted rounded-lg p-3">
                <div className="flex items-center space-x-2 mb-1">
                  <Icon name="Target" size={14} className="text-accent" />
                  <span className="text-xs font-medium text-text-primary">Focus</span>
                </div>
                <p className="text-xs text-text-secondary">{rec.service.focusArea}</p>
              </div>
              <div className="bg-muted rounded-lg p-3">
                <div className="flex items-center space-x-2 mb-1">
                  <Icon name="TrendingUp" size={14} className="text-success" />
                  <span className="text-xs font-medium text-text-primary">Impact</span>
                </div>
                <p className="text-xs text-text-secondary">{rec.service.avgImpact}</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-2">
              <Button
                variant="outline"
                size="sm"
                iconName="FileText"
                iconPosition="left"
                onClick={() => onServiceSelect(rec.service.id, 'learn-more')}
                className="flex-1"
              >
                Learn More
              </Button>
              <Button
                variant={index === 0 ? "default" : "outline"}
                size="sm"
                iconName="Play"
                iconPosition="left"
                onClick={() => onServiceSelect(rec.service.id, 'assessment')}
                className={`flex-1 ${index === 0 ? 'bg-accent hover:bg-accent/90' : ''}`}
              >
                Start Assessment
              </Button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Lightbulb" size={20} className="text-warning flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="font-medium text-text-primary mb-1">Next Steps</h4>
            <p className="text-sm text-text-secondary">
              Start with an assessment of your top recommendation, or schedule a discovery call to discuss a combined approach addressing multiple challenges.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendationResults;